import React, { useState, useEffect } from 'react';
import './Box.css';

const BoxTabs = ({ tabs, defaultTabIndex = 0, isSmallScreen }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(defaultTabIndex);
    const [mountedTabs, setMountedTabs] = useState(new Set([defaultTabIndex]));

    // Add new tab to mounted tabs when switching to it for the first time
    const handleTabClick = (tabIndex) => {
        setActiveTabIndex(tabIndex);
        setMountedTabs(prev => new Set([...prev, tabIndex]));
    };

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            {/* Tab Navigation */}
            <div className="box-tabs-navigation">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        className={`box-tab-button ${activeTabIndex === index ? 'active' : ''}`}
                        onClick={() => handleTabClick(index)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="box-tabs-content">
                {tabs.map((tab, index) => (
                    <div
                        key={index}
                        className={`box-tab-panel ${activeTabIndex === index ? 'active' : 'hidden'}`}
                        style={{ display: activeTabIndex === index ? 'block' : 'none' }}
                    >
                        {mountedTabs.has(index) && (
                            <tab.component
                                {...tab.props}
                                isSmallScreen={isSmallScreen}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BoxTabs;
